import React, {useState} from 'react'
import { Container, Button, TextField, Typography } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { buildPathWithId } from 'utils/path';
// import { useRoomList } from 'hooks/use-room-list';
import { useHistory } from 'react-router-dom';
import { Routing } from 'components/pages/routes';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    alignItems: 'flex-end',
  },
}));

export const MakeRoom: React.FC = () => {
  const classes = useStyles();
  const { push } = useHistory();
  
  // const { makeRoom } = useRoomList();
  const [ roomName, setRoomName ] = useState<string>('');

  const handleSubmit = () =>{
    if (roomName) {
      // const room = makeRoom(roomName);
      push(buildPathWithId(Routing.RoomPath, roomName));
    }
  }

  return (<>
    <Typography variant="h6">{`ルームを作成`}</Typography>
    <Container className={classes.container} maxWidth="xs">
    <TextField
      fullWidth
      required
      label="ルーム"
      type="text"
      helperText="ルームの名前を入れる"
      onChange={(event) => setRoomName(event.target.value)}
    />

    <Button
      fullWidth
      variant="contained"
      size="large"
      color="secondary"
      onClick={handleSubmit}
      >はいる</Button>
    </Container>


  </>);
};

